import { employeeHomeRedirect } from './employee/employee-entry';
import { environment as workforceEnvironment } from '../environments/environment';
import { employeeGuard } from './employee/employee.guard';
import { Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { isRoleGuard } from './guards/is-role.guard';
import { isSiteleadGuard } from './guards/sitelead.guard';
import { ImportProspectsPage } from './imports/prospects/import-prospects.page';
import { InvitesPage } from './invites/invites.page';
import { InvoicingPage } from './invoicing/invoicing.page';
import { ContractsPage } from './offers/contracts.page';
import { OffersPage } from './offers/offers.page';
import { PartnerLivePage } from './partner/live/live.page';
import { PartnerMenuPage } from './partner/menu/menu.page';
import { PartnerNotesPage } from './partner/notes/partner-notes.page';
import { PartnerSalesPage } from './partner/sales/sales.page';
import { PrivacyPage } from './privacy/privacy.page';
import { ProjectsPage } from './projects/projects.page';
import { SignaturePage } from './signature/signature.page';
import { StripeCancelPage } from './stripe/cancel/cancel.page';
import { StripeOrderPage } from './stripe/order/order.page';
import { StripeSuccessPage } from './stripe/success/success.page';
import { SuperAdminAiUsagePage } from './super-admin/ai-usage/ai-usage.page';
import { SuperAdminMenuPage } from './super-admin/menu.page';
import { SupportPage } from './support/support.page';
import { TemplatesPage } from './templates/templates.page';
import { UiShowroomPage } from './ui/showroom/ui-showroom.page';
import { Roles } from './utility/role';
import { ShiftPage } from './work-force/shift.page';
import { TicketPageComponent } from './worker/ticket/ticket.page';

export const routes: Routes = [
  { path: 'employee', loadComponent: async () => import('./employee/employee-shell').then(m => m.EmployeeShell), canActivate: [() => workforceEnvironment.firebase.projectId === 'isoharja-demo', employeeGuard], children: [
    {path:'', pathMatch:'full', loadComponent:async ()=>import('./employee/employee.page').then(m=>m.EmployeePage)},
    {path:'jobs', loadComponent:async()=>import('./employee/employee-jobs').then(m=>m.EmployeeJobs)},
    {path:'jobs/:id', loadComponent:async()=>import('./employee/employee-task-detail').then(m=>m.EmployeeTaskDetail)},
    {path:'time',loadComponent:async()=>import('./employee/employee-time').then(m=>m.EmployeeTime)},
    {path:'profile',loadComponent:async()=>import('./employee/employee-me').then(m=>m.EmployeeMe)},
    {path:'me',pathMatch:'full',redirectTo:'profile'},
  ] },
  { path: 'workforce-v2/requirements/:id', loadComponent: async () => import('./workforce-v2/workforce.page').then(m => m.WorkforcePage), canActivate: [() => workforceEnvironment.firebase.projectId === 'isoharja-demo'] },
  { path: 'workforce-v2/:section', loadComponent: async () => import('./workforce-v2/workforce.page').then(m => m.WorkforcePage), canActivate: [() => workforceEnvironment.firebase.projectId === 'isoharja-demo'] },
  {
    path: 'clients',
    loadChildren: async () =>
      import('./clients/clients.routing.module'),
  },
  {
    path: 'contractors',
    loadChildren: async () =>
      import('./contractors/contractors.routing.module'),
  },
  {
    path: 'dashboard',
    loadChildren: async () =>
      import('./dashboard/dashboard.routing.module'),
  },
  {
    path: 'feedback',
    loadChildren: async () =>
      import('./feedback/feedback.routing.module'),
  },
  {
    path: 'import/prospects',
    component: ImportProspectsPage,
    canActivate: [isRoleGuard([Roles.superAdmin])],
  },
  {
    path: 'info',
    loadChildren: async () =>
      import('./info/info.routing.module'),
  },
  {
    path: 'partner/invites',
    component: InvitesPage,
  },
  {
    path: 'partner/live',
    component: PartnerLivePage,
    canActivate: [isRoleGuard([Roles.superAdmin, Roles.partner, Roles.premiumPartner])],
  },
  {
    path: 'partner/menu',
    component: PartnerMenuPage,
    canActivate: [isRoleGuard([Roles.partner, Roles.premiumPartner])],
  },
  {
    path: 'partner/notes',
    component: PartnerNotesPage,
    canActivate: [isRoleGuard([Roles.superAdmin, Roles.partner, Roles.premiumPartner])],
  },
  {
    path: 'partner/sales',
    component: PartnerSalesPage,
    canActivate: [isRoleGuard([Roles.superAdmin, Roles.partner, Roles.premiumPartner])],
  },
  {
    path: 'partner/offers',
    component: OffersPage,
    canActivate: [isRoleGuard([Roles.superAdmin, Roles.partner, Roles.premiumPartner])],
  },
  {
    path: 'partner/contracts',
    component: ContractsPage,
    canActivate: [isRoleGuard([Roles.superAdmin, Roles.partner, Roles.premiumPartner])],
  },
  {
    path: 'privacy',
    component: PrivacyPage,
  },
  {
    path: 'invoice',
    loadChildren: async () =>
      import('./invoice/invoice.routing.module'),
  },
  {
    path: 'home',
    canActivate: [employeeHomeRedirect],
    loadChildren: async () =>
      import('./home/home.routing.module'),
  },
  {
    path: 'instructions',
    loadChildren: async () =>
      import('./instructions/instructions.routing.module'),
  },
  {
    path: 'invoicing',
    component: InvoicingPage,
    canActivate: [isRoleGuard([Roles.superAdmin])],
  },
  {
    path: 'lastplanner',
    loadChildren: async () =>
      import('./lastplanner/lastplanner.routing.module'),
  },
  {
    path: 'littera',
    loadChildren: async () =>
      import('./littera/littera.routing.module'),
  },
  {
    path: 'login',
    loadChildren: async () =>
      import('./login/login.routing.module'),
  },
  {
    path: 'logs',
    loadChildren: async () =>
      import('./logs/logs-page.routing.module'),
  },
  {
    path: 'manager',
    loadChildren: async () =>
      import('./manager/manager.routing.module'),
  },
  {
    path: 'materials',
    loadChildren: async () =>
      import('./materials/materials.routing.module'),
  },
  {
    path: 'merge-users',
    loadChildren: async () =>
      import('./merge-users/merge-users.routing.module'),
  },
  {
    path: 'options',
    loadChildren: async () =>
      import('./options/options.routing.module'),
    canActivate: [isRoleGuard([
      Roles.admin,
      Roles.superAdmin,
      Roles.supervisor,
      Roles.manager,
      Roles.managerWorker,
      Roles.storage,
      Roles.partner,
      Roles.premiumPartner,
      Roles.lastplanner,
      Roles.calendar,
      Roles.serviceInstructor,
      Roles.sales,
    ])],
  },
  {
    path: 'projects/:project',
    loadComponent: async () =>
      (await import('./site-project/project/project.page')).SiteProjectPage,
    canActivate: [isRoleGuard([Roles.admin, Roles.supervisor, Roles.manager, Roles.managerWorker, Roles.sales])],
  },
  {
    path: 'projects',
    component: ProjectsPage,
    canActivate: [isRoleGuard([Roles.admin, Roles.supervisor, Roles.manager, Roles.managerWorker, Roles.sales])],
  },
  {
    path: 'register',
    loadChildren: async () =>
      import('./register/register.routing.module'),
  },
  {
    path: 'schedule',
    loadChildren: async () =>
      import('./schedule/schedule.routing.module'),
  },
  {
    path: 'sign-up',
    loadChildren: async () =>
      import('./on-boarding/on-boarding.routing.module'),
  },
  {
    path: 'signature/:id',
    component: SignaturePage,
  },
  {
    path: 'support',
    component: SupportPage,
    canActivate: [isRoleGuard([
      Roles.worker,
      Roles.admin,
      Roles.manager,
      Roles.storage,
      Roles.lastplanner,
      Roles.superAdmin,
      Roles.partner,
      Roles.premiumPartner,
      Roles.supervisor,
      Roles.calendar,
      Roles.managerWorker,
      Roles.serviceInstructor,
      Roles.sales,
    ])],
  },
  {
    path: 'sites',
    loadChildren: async () =>
      import('./sites/sites.routing.module'),
  },
  {
    path: 'maintenance/data-health',
    loadComponent: async () => import('./super-admin/data-health/data-health.page').then(m => m.DataHealthPage),
    canActivate: [isRoleGuard([Roles.superAdmin])],
  },
  {
    path: 'super-admin/ai-usage',
    component: SuperAdminAiUsagePage,
    canActivate: [isRoleGuard([Roles.superAdmin])],
  },
  {
    path: 'super-admin/sites',
    loadComponent: async () =>
      (await import('./contractors/super-admin-sites.page')).SuperAdminSitesPage,
    canActivate: [isRoleGuard([Roles.superAdmin])],
  },
  {
    path: 'super-admin/menu',
    component: SuperAdminMenuPage,
    canActivate: [isRoleGuard([Roles.superAdmin])],
  },
  {
    path: 'super-admin/templates',
    component: TemplatesPage,
    canActivate: [isRoleGuard([Roles.superAdmin])],
  },
  {
    path: 'stripe/order',
    component: StripeOrderPage,
  },
  {
    path: 'stripe/success',
    component: StripeSuccessPage,
  },
  {
    path: 'stripe/cancel',
    component: StripeCancelPage,
  },
  {
    path: 'ticket',
    component: TicketPageComponent,
  },
  {
    path: 'ui-showroom',
    component: UiShowroomPage,
  },
  {
    path: 'users',
    loadChildren: async () =>
      import('./users/users.routing.module'),
  },
  {
    path: 'waiting',
    loadChildren: async () =>
      import('./waiting/waiting.routing.module'),
  },
  {
    path: 'worker',
    loadChildren: async () =>
      import('./worker/worker.routing.module'),
  },
  {
    path: 'working-calendar',
    loadChildren: async () =>
      import('./working-calendar/working-calendar.routing.module'),
  },
  {
    path: 'worklist',
    component: ShiftPage,
    canActivate: [isRoleGuard([Roles.admin, Roles.supervisor])],
  },
  {
    path: '',
    redirectTo: environment.home,
    pathMatch: 'full',
  },
];
